/** Mobilidade Elétrica proposal questionnaire (Solicitar Proposta). */

export const MOBILIDADE_FIELD_KEYS = [
  'plataformaGestao',
  'localInstalacao',
  'quadroMobilidade',
  'tipoFixacao',
  'tipoCarregamento',
  'distanciaQveProximo',
  'distanciaQveDistante',
] as const;

export type MobilidadeFieldKey = (typeof MOBILIDADE_FIELD_KEYS)[number];

export const MOBILIDADE_FIELD_LABELS: Record<MobilidadeFieldKey, string> = {
  plataformaGestao: 'Selecione a plataforma de gestão',
  localInstalacao: 'Onde será realizada a instalação?',
  quadroMobilidade: 'Pretende ter quadro de mobilidade elétrica?',
  tipoFixacao: 'Qual o tipo de fixação?',
  tipoCarregamento: 'Qual o tipo de carregamento que melhor se adequa à sua frota?',
  distanciaQveProximo: 'Distância do QVE/QE ao lugar mais próximo',
  distanciaQveDistante: 'Distância do QVE/QE ao lugar mais distante',
};

export const MOBILIDADE_OPTION_LABELS: Partial<
  Record<MobilidadeFieldKey, Record<string, string>>
> = {
  plataformaGestao: {
    'sem-gestao': 'Sem gestão',
    'edp-charge': 'EDP Charge',
  },
  localInstalacao: {
    interior: 'Interior',
    exterior: 'Exterior',
  },
  quadroMobilidade: {
    sim: 'Sim',
    nao: 'Não',
  },
  tipoFixacao: {
    solo: 'Solo',
    parede: 'Parede',
  },
  tipoCarregamento: {
    normal: 'Normal: carrega 100 Km entre 4 horas e 40 min [3,7 - 22kVA]',
    rapido: 'Rápido: carrega 100Km em 20 min (45 kW)',
  },
};

export function formatMobilidadeFieldValue(
  field: string,
  value: unknown
): string {
  if (value == null || value === '') return '';
  const raw = String(value);
  const options = MOBILIDADE_OPTION_LABELS[field as MobilidadeFieldKey];
  if (options && options[raw]) return options[raw];
  return raw;
}

export type MobilidadeDetailRow = { key: string; label: string; value: string };

/** Display rows for Quadro de Propostas / RequestCard (skips empty; keeps legacy fields). */
export function getMobilidadeDetailRows(
  details: Record<string, unknown> | null | undefined
): MobilidadeDetailRow[] {
  if (!details || typeof details !== 'object') return [];
  const rows: MobilidadeDetailRow[] = [];

  for (const fieldKey of MOBILIDADE_FIELD_KEYS) {
    const display = formatMobilidadeFieldValue(fieldKey, details[fieldKey]);
    if (!display) continue;
    rows.push({
      key: fieldKey,
      label: MOBILIDADE_FIELD_LABELS[fieldKey],
      value: display,
    });
  }

  // Legacy submissions (pre-questionnaire)
  if (details.tipoCarregador) {
    rows.push({
      key: 'tipoCarregador',
      label: 'Tipo de Carregador',
      value: String(details.tipoCarregador),
    });
  }
  if (details.potencia && !details.tipoCarregamento) {
    rows.push({
      key: 'potencia',
      label: 'Potência',
      value: String(details.potencia),
    });
  }
  if (details.observacoes) {
    rows.push({
      key: 'observacoes',
      label: 'Observações',
      value: String(details.observacoes),
    });
  }

  return rows;
}

export function isMobilidadeServiceType(serviceType: unknown): boolean {
  return String(serviceType || '')
    .trim()
    .toLowerCase() === 'mobilidade';
}
